import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { STARTER, FREE } from 'self-service-api/constants/ProductLevels';
import { OLAF } from 'HubStyleTokens/colors';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import FeatureTableFreePriceDisplay from './FeatureTableFreePriceDisplay';
import { EBX633_LP } from '../../constants/tracking/Locations';
import BestValueBadge from '../common/BestValueBadge';
import { CrmSuitePrice } from '../merch-card/price-display/CrmSuitePrice';
import CurrentPlanButton from '../ebx633/CurrentPlanButton';
import { ownsCrmSuiteProductLevel } from '../../selectors/ProductInventorySelectors';
import FeatureTableHeaderCellCTA from './FeatureTableTableHeaderCellCTA';
const TableHeaderCell = styled.th.withConfig({
  displayName: "EbxFeatureTableHeaderCell__TableHeaderCell",
  componentId: "sc-3op924-0"
})(["text-align:center;font-weight:normal;background-color:", ";position:", ";box-shadow:", ";width:calc(50% / ", ");padding:16px 0;"], ({
  isCurrentPlanLevel
}) => !isCurrentPlanLevel && `${OLAF}`, ({
  isRecommendedPlan
}) => isRecommendedPlan && 'relative', ({
  isRecommendedPlan
}) => isRecommendedPlan && 'inset 0px 4px 4px rgba(124, 152, 182, 0.2)', ({
  numOfLevels
}) => numOfLevels);
const StyledBestValueBadge = styled(BestValueBadge).withConfig({
  displayName: "EbxFeatureTableHeaderCell__StyledBestValueBadge",
  componentId: "sc-3op924-1"
})(["position:absolute;top:16px;left:calc(50% - 50px);width:100px;"]);

const EbxFeatureTableHeaderCell = ({
  productLevel,
  numOfLevels
}) => {
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const isRecommendedPlan = productLevel === STARTER;
  const isFree = productLevel === FREE;
  const contentProps = {
    productLevel,
    concise: true
  };
  const isCurrentPlanLevel = useSelector(state => ownsCrmSuiteProductLevel(state, {
    productLevel
  }));
  return /*#__PURE__*/_jsxs(TableHeaderCell, {
    isRecommendedPlan: isRecommendedPlan,
    numOfLevels: numOfLevels,
    isCurrentPlanLevel: isCurrentPlanLevel,
    children: [isRecommendedPlan && /*#__PURE__*/_jsx(StyledBestValueBadge, {
      message: 'recommended',
      isEbx633: true
    }), /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `products.crm.${productLevel}`
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "m-y-1",
      children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !hasPricingAndPurchasingSucceeded,
        heights: [19],
        widths: [190],
        className: "flex-column m-y-2",
        Content: isFree ? FeatureTableFreePriceDisplay : CrmSuitePrice,
        contentProps: isFree ? {} : contentProps
      })
    }), isCurrentPlanLevel ? /*#__PURE__*/_jsx(CurrentPlanButton, {
      ctaStyles: {
        width: '154px',
        padding: '11px 12px'
      }
    }) : /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
      isLoading: !hasPricingAndPurchasingSucceeded,
      heights: [40],
      children: /*#__PURE__*/_jsx(FeatureTableHeaderCellCTA, {
        productLevel: productLevel,
        trackingSource: EBX633_LP
      })
    })]
  });
};

export default EbxFeatureTableHeaderCell;